import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string(),
  VITE_BRANDING_ASSETS_BASE_PATH: z.string(),
  VITE_VOUCHED_PUBLIC_KEY: z.string(),
  VITE_PAYCONEX_IFRAME_ACC_ID: z.string(),
  VITE_PAYCONEX_IFRAME_DEV_SERVER: z.string(),
  VITE_HOSTED_PCI_BASE_URL: z.string(),
  VITE_SUPPORT_EMAIL: z.string(),
  VITE_SUPPORT_PHONE: z.string(),
  VITE_APPINSIGHTS_CONNECTION_STRING: z.string().optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  /* eslint-disable-next-line no-console */
  console.error(
    '❌ Invalid environment variables. Please check environment configuration.',
    parsed.error,
  );
  throw new Error('Invalid environment variables');
}

export const env = parsed.data;
